import configuratorChoices from '~/data/configuratorChoices/bagConfiguratorChoices';
import canConfiguratorChoices from '~/data/configuratorChoices/canConfiguratorChoices';
import { ProductViewConfigurator } from '~/types/configurator';

let label;
let imageUrl;
let description;

export default {
    controls: [
        {
            key: 'color',
            keyLabel: 'color',
            label: 'Color',
            displayAsImages: true,
            choices: [
                {
                    label: (label = 'Silver'),
                    detailsModalLabel: label,
                    imageUrl: (imageUrl =
                        '/images/configurator-choices/color-metal.webp'),
                    detailsModalImageUrl: imageUrl,
                    value: 'silver',
                    description: (description =
                        'Silver-colored metal tin can which is curbside recyclable.'),
                    detailsModalDescription: description,
                },
                configuratorChoices.colors.customWithPattern,
            ],
            detailsModalLabel: 'Color options:',
        },
        {
            key: 'type',
            keyLabel: 'can type',
            label: 'Tin Can Type',
            choices: [
                {
                    label: (label = 'Beaded'),
                    detailsModalLabel: label,
                    value: 'beaded',
                    description: (description =
                        '4.0625” diameter × 5.5” height<br />' +
                        'Our beaded tin cans hold approximately 8–12 oz of whole coffee beans (fill testing recommended) and stand 5.5” tall.'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = 'Straight'),
                    detailsModalLabel: label,
                    value: 'straight',
                    description: (description =
                        '4.0625” diameter × 4” height<br />' +
                        '4.0625” diameter × 7” height<br />' +
                        'Our straight tin cans hold between 6–16 oz of coffee — and are available in two sizes, standing either 4″ or 7″ tall (fill testing recommended).'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Tin can type options:',
        },
        canConfiguratorChoices.size,
        {
            key: 'lid',
            keyLabel: 'lid type',
            label: 'Lid Style',
            choices: [
                {
                    label: (label = 'Metal'),
                    detailsModalLabel: label,
                    value: 'metal',
                    description: (description =
                        'Made of tin-coated steel, this lid can be curbside recycled. Leave the lid on the can to ensure proper disposal.'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = 'Black'),
                    detailsModalLabel: label,
                    value: 'black',
                    description: (description =
                        'A black plastic reusable lid made of HDPE, recyclable under Resin #2.'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = 'Clear'),
                    detailsModalLabel: label,
                    value: 'clear',
                    description: (description =
                        'A clear (slightly hazy) plastic reusable lid made of HDPE,recyclable under Resin #2.'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Lid style options:',
        },
    ],
} as ProductViewConfigurator;
